import InsurerPartnerLogo from "@/components/InsurerPartnerLogo";

export default function InsurerPartnersHomeSection({ t, lang = "ro" }) {
  const { insurerPartnersHome: c } = t;
  if (!c?.partners?.length) return null;

  const claimsHref =
    lang === "ro" ? "/constatari-daune" : `/constatari-daune?lang=${lang}`;

  return (
    <section
      id="parteneri-rca"
      data-testid="insurer-partners-home-section"
      className="bg-[#f7f8fa] border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="max-w-3xl">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
            {c.eyebrow}
          </div>
          <h2 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">
            {c.title}
          </h2>
          <p className="mt-5 text-slate-600 text-sm sm:text-base leading-relaxed">
            {c.lead}
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-2">
          {c.partners.map((p, i) => (
            <a
              key={i}
              data-testid={`insurer-partner-home-${i}`}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              title={p.url}
              className="inline-flex max-w-full shrink-0 items-center gap-2 border border-[#e2e6ec] bg-white text-slate-700 font-mono text-xs uppercase tracking-wider px-3 py-2 hover:border-[#0b378c] hover:text-[#0b378c] transition-colors shadow-sm"
            >
              <InsurerPartnerLogo url={p.url} />
              <span className="min-w-0 whitespace-normal break-words leading-snug">{p.name}</span>
              <span className="text-[#e3191b] text-[10px]">↗</span>
            </a>
          ))}
        </div>

        {c.disclaimer ? (
          <p className="mt-8 text-xs text-slate-500 leading-relaxed max-w-4xl">{c.disclaimer}</p>
        ) : null}

        {c.cta ? (
          <div className="mt-6">
            <a
              href={claimsHref}
              className="font-mono text-xs uppercase tracking-wider text-[#0b378c]"
            >
              {c.cta}
            </a>
          </div>
        ) : null}
      </div>
    </section>
  );
}
